// Company definitions used across the application
export const COMPANIES = [
  { value: "all", label: "All Companies", logo: null },
  { value: "empact-studio", label: "Empact Studio", logo: "/logos/empact-studio.jpg" },
  { value: "event-resource", label: "Event Resource", logo: "/logos/event-resource.png" },
  { value: "vijay-sabhlok", label: "Vijay Sabhlok", logo: "/logos/vijay-sabhlok.jpg" },
];

export const COMPANY_OPTIONS = COMPANIES.filter(c => c.value !== "all");

export const getCompanyLabel = (value) => {
  const company = COMPANIES.find(c => c.value === value);
  return company ? company.label : value;
};

export const getCompanyLogo = (value) => {
  const company = COMPANIES.find(c => c.value === value);
  return company ? company.logo : null;
};

// Brand-aligned company colors (Navy Blue, Golden Orange, Gray)
export const COMPANY_COLORS = {
  "empact-studio": "bg-[#1E3A5F]/10 text-[#1E3A5F] border border-[#1E3A5F]/20",
  "event-resource": "bg-[#F5A623]/15 text-[#b07a16] border border-[#F5A623]/30",
  "vijay-sabhlok": "bg-slate-100 text-slate-700 border border-slate-200",
  "all": "bg-slate-100 text-slate-700 border border-slate-200",
};
